import CreateObject from './CreateObject';
import UpdateObject from './UpdateObject';

import { useEffect } from 'react';

const DetailsSection = props => {
	useEffect(() => {}, [props.updateObject]);

	return (
		<>
			{props.new === true ? (
				<CreateObject {...props} />
			) : (
				<UpdateObject {...props} />
			)}
		</>
	);
};

export default DetailsSection;
